import { startCase } from 'lodash';
import * as Yup from 'yup';

import { dayjs } from '@ui';

import {
  ANNUAL_INCOME_PARAM_NAME,
  DOB_PARAM_NAME,
  EXPENSES_PARAM_NAME,
  GENDER_PARAM_NAME,
  PINCODE_PARAM_NAME
} from '../../utils/constants';

import { SessionStorage } from './storage';

const logParamError = (name: string, error: string) => {
  // don't remove
  console.log(`APP Params[${name}]: ${error ? error : 'Invalid param'}`);
};

export const storeAppParams = (urlParams: any) => {
  const annInc = urlParams.get(ANNUAL_INCOME_PARAM_NAME);
  const dob = urlParams.get(DOB_PARAM_NAME);
  const dobDate = dob ? dayjs(dob, 'DD-MM-YYYY', true) : undefined;
  const mExpenses = urlParams.get(EXPENSES_PARAM_NAME);
  let gender = startCase(urlParams.get(GENDER_PARAM_NAME));
  gender = gender === 'Others' ? 'Transgender' : gender;

  const minDate = dayjs()
    .subtract(60, 'years')
    .subtract(364, 'days')
    .format('DD/MM/YYYY');
  const minDateISO = dayjs()
    .subtract(60, 'years')
    .subtract(364, 'days')
    .toISOString();
  const maxDate = dayjs().subtract(18, 'years').format('DD/MM/YYYY');
  const maxDateISO = dayjs().subtract(18, 'years').toISOString();

  const dobSchema = Yup.date()
    .typeError('Invalid date')
    .nullable()
    .max(maxDateISO, `Date of birth must be later than ${maxDate}`)
    .min(minDateISO, `Date of birth must be earlier than ${minDate}`);

  const genderSchema = Yup.string().oneOf(['Male', 'Female', 'Transgender']);

  const annIncSchema = Yup.number()
    .min(300000, 'annInc has to be greater than 3 lakhs to buy a term policy')
    .max(50000000, 'annInc max allowed 5 Cr');

  const mExpSchema = Yup.number()
    .min(1, 'mExp should be greater than 0')
    .test(
      'compareannInc',
      'mExp should be less than monthly income',
      function (value) {
        if (
          annInc &&
          parseInt(annInc) > 0 &&
          value &&
          parseInt(annInc) / 12 < value
        ) {
          return false;
        }
        return true;
      }
    );

  const appParams = [
    {
      param: GENDER_PARAM_NAME,
      schema: genderSchema,
      value: gender
    },
    {
      param: DOB_PARAM_NAME,
      schema: dobSchema,
      value: dobDate,
      store: dob
    },
    {
      param: ANNUAL_INCOME_PARAM_NAME,
      schema: annIncSchema,
      value: annInc
    },
    {
      param: EXPENSES_PARAM_NAME,
      schema: mExpSchema,
      value: mExpenses
    }
  ];

  appParams.forEach((appParam: any) => {
    if (appParam.value) {
      let validate = true;
      // incase of dates check if date format is valid
      if (dayjs.isDayjs(appParam.value)) {
        if (!appParam.value.isValid()) {
          logParamError(appParam.param, 'Invlid date format');
          SessionStorage?.remove(appParam.param);
          validate = false;
        }
      }
      if (validate) {
        appParam.schema
          .validate(appParam.value)
          .then(() => {
            SessionStorage?.set(
              appParam.param,
              appParam.store ? appParam.store : appParam.value
            );
          })
          .catch((err: any) => {
            SessionStorage?.remove(appParam.param);
            logParamError(
              appParam.param,
              ` ${err && err.message ? err.message : 'Invalid param'}`
            );
          });
      }
    }
  });
};

export const getAppParams = () => {
  const gender = SessionStorage?.get(GENDER_PARAM_NAME);
  const dob = SessionStorage?.get(DOB_PARAM_NAME);
  const dobDate = dayjs(dob, 'DD-MM-YYYY');
  const annInc = parseInt(SessionStorage?.get(ANNUAL_INCOME_PARAM_NAME));
  const mExpenses = parseInt(SessionStorage?.get(EXPENSES_PARAM_NAME));
  const pinCode = SessionStorage?.get(PINCODE_PARAM_NAME);

  return {
    dob: dobDate ? dobDate : null,
    gender: gender ? gender : undefined,
    annInc: annInc ? annInc : 0,
    mExpenses: mExpenses ? mExpenses : 0,
    pinCode: pinCode ? pinCode : ''
  };
};
